import { createContext } from 'react';

import type { CurrentUser } from './authApi.ts';

export interface AuthContextValue {
  user: CurrentUser | null;
  /** True while we are still working out whether there is a session. */
  isLoading: boolean;
  isAuthenticated: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => void;
}

/**
 * Lives in its own module so that AuthProvider.tsx exports a component and nothing
 * else — a file that mixes components with other exports loses Fast Refresh.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);
